import BatteryGraphList from './BatteryGraphList'

export default BatteryGraphList;